import { z } from 'zod';
import { ApplicationStatuses } from '@/constants/UK/ApplicationStatus';
import { ApplicationRejectReasons } from '@/constants/UK/rejectReasons';

export const createApplicationResponseSchema = z.object({
  id: z.string(),
});

const creditTierSchema = z.object({
  id: z.string(),
  creditLimit: z.number(),
  interestRate: z.number(),
});
export const getCreditTierResponseSchema = creditTierSchema.array();

const productTierFeesSchema = z.object({
  withdrawalFee: z.number(),
  setupFee: z.number(),
  installmentFee: z.number(),
});

export const productTierSchema = z.object({
  id: z.string(),
  amount: z.number(),
  effectiveInterest: z.number(),
  interest: z.number(),
  monthlyPayment: z.number(),
  period: z.number(),
  totalAmount: z.number(),
  totalCost: z.number(),
  fees: productTierFeesSchema,
});

export const applicationPendingResponseSchema = z.object({
  status: z.literal(ApplicationStatuses.PENDING),
  id: z.string(),
});

export const applicationRejectedResponseSchema = z.object({
  status: z.literal(ApplicationStatuses.REJECTED),
  id: z.string(),
  reason: z.enum(ApplicationRejectReasons),
});
export const applicationManualApprovalResponseSchema = z.object({
  status: z.literal(ApplicationStatuses.MANUAL_APPROVAL),
  id: z.string(),
  reasons: z
    .enum([
      'noticeOfCorrection',
      'politicallyExposedPerson',
      'selfEmployedIncomeVerification',
      'partTimeVariableIncome',
    ])
    .array(),
});

export const applicationApprovedResponseSchema = z
  .object({
    status: z.literal(ApplicationStatuses.APPROVED),
    id: z.string(),
    offeredProductTiers: productTierSchema.array(),
    authToken: z.string(),
  })
  .and(
    z.union([
      z.object({ sourceType: z.literal('ORGANIC') }),
      z.object({
        sourceType: z.literal('BROKER'),
        advertiserName: z.string().optional(),
      }),
      // TODO: Remove this once the endpoint has been updated https://fairloo.atlassian.net/browse/FCUK-2104
      z.object({ sourceType: z.undefined().optional() }),
    ]),
  );

// Using a z.discriminatedUnion causes a type error due to the union in the
// applicationApprovedResponseSchema
export const getApplicationResponseSchema = z.union([
  applicationPendingResponseSchema,
  applicationRejectedResponseSchema,
  applicationManualApprovalResponseSchema,
  applicationApprovedResponseSchema,
]);

const documentStatusSchema = z.enum(['signed', 'unsigned']);

export const documentsResponseSchema = z.object({
  summary: documentStatusSchema,
  creditInformation: documentStatusSchema,
  creditAgreement: documentStatusSchema,
  termsAndConditions: documentStatusSchema,
});
